module.exports = __webpack_public_path__ + "img/66_5.4256973e.png";